import fetch from 'cross-fetch';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { isProductionDomain } from '@lib/utils';
import { callerIdHeaders } from '@lib/caller-id';

let endpoint;
let isProduction = isProductionDomain();

if (typeof window === 'undefined' && isProduction) {
  // Production, Server Side
  endpoint = 'https://api.sibcycline.com/v2/graphql';
} else if (typeof window === 'undefined' || process.env.NEXT_PUBLIC_LOCAL_ENV) {
  // Non-Production, Server Side
  endpoint = 'https://api-staging.sibcycline.com/v2/graphql';
} else {
  // Production & Non-Production, Client Side, Proxy
  endpoint = `${window.location.origin}/graphql`;
}

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({ fetch, headers: callerIdHeaders(), uri: endpoint }),
  connectToDevTools: !isProduction
});

export default client;
